import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AutomationOpenedLocation, withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationOpened.meta';

export type UseTrackAutomationOpenedParams = {
  automation_id: string;
  location: AutomationOpenedLocation;
};

export const useTrackAutomationOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationOpened = useCallback(
    (params: UseTrackAutomationOpenedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationOpened };
};
